import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizedGuard } from '../../authorization/guards/authorized.guard';
import { SplashViewComponent } from '../../core/components/splash-view/splash-view.component';
import { AgreementComponent } from '../components/agreement/agreement.component';
import { AuthenticateComponent } from '../components/authenticate/authenticate.component';
import { ResetPasswordComponent } from '../components/reset-password/reset-password.component';
import { UnauthorizedComponent } from '../components/unauthorized/unauthorized.component';

const routes: Routes = [
  {
    path: '',
    component: SplashViewComponent,
    children: [
      {
        path: 'agreement',
        canActivate: [AuthorizedGuard],
        component: AgreementComponent,
        data: {
          showAppHeader: false,
          showAppSidebar: false,
        },
      },
      {
        path: 'login',
        canActivate: [AuthorizedGuard],
        component: AuthenticateComponent,
        data: {
          showAppHeader: false,
          showAppSidebar: false,
        },
      },
      {
        path: 'reset-password',
        canActivate: [AuthorizedGuard],
        component: ResetPasswordComponent,
        data: {
          showAppHeader: false,
          showAppSidebar: false,
        },
      },
    ],
  },
  {
    path: 'logout',
    canActivate: [AuthorizedGuard],
    children: [],
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    data: {
      title: 'Unauthorized',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class AuthenticationRoutingModule {}
